import { startLoading, stopLoading } from 'actions/Loading';
import api from 'api';
import { ExamEnum } from 'constants/types/Exam';
import { IThunkAction } from 'constants/types/IThunkAction';
import { errorHandler } from 'helpers/errorHandler';

export const getUnfinishedExam = (): IThunkAction => async (
  dispatch,
): Promise<void> => {
  try {
    startLoading()(dispatch);
    const response = await api.get(
      // eslint-disable-next-line max-len
      'Exams/user-exam?filter={"where":{"isFinished":false}, "include" : "defaultUser"}',
    );
    dispatch({
      type: ExamEnum.FETCH_UNFINISHED_EXAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    errorHandler(error);
    dispatch({
      type: ExamEnum.FETCH_UNFINISHED_EXAM_FAILURE,
      payload: error,
    });
  }
  stopLoading()(dispatch);
};
